import { useState } from 'react';
import { Spinner } from '../shared/Spinner';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  busy?: boolean;
}

export function RejectModal({ open, onClose, onConfirm, busy }: Props) {
  const [reason, setReason] = useState('');
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-5"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold">Rejeter cette facture</h2>
        <p className="text-sm text-slate-500 mt-1">
          Indique la raison du rejet. Elle sera conservée dans l'historique.
        </p>
        <textarea
          autoFocus
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Ex: Doublon avec FAC-2026-001, hors périmètre, facture déjà payée…"
          rows={4}
          className="mt-3 w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="px-3 py-1.5 rounded-md text-sm font-medium text-slate-700 hover:bg-slate-100"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason.trim())}
            disabled={busy || reason.trim().length === 0}
            className="px-3 py-1.5 rounded-md text-sm font-medium bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 inline-flex items-center gap-2"
          >
            {busy && <Spinner />}
            {busy ? 'Rejet…' : 'Confirmer le rejet'}
          </button>
        </div>
      </div>
    </div>
  );
}
